/**
 * The controls help (PHASE3 T3.7): only controls the merged game has (M-001 … M-007: jump,
 * double jump, item, ride; no slide or sprint). `code` is the `KeyboardEvent.code` the game
 * reads (`game/Input.ts` KEY_BITS, the emote and mute handlers), checked by a test so the help
 * cannot drift from the bindings.
 */
export interface KeyCap {
  label: string
  code: string
}

export interface ControlRow {
  action: string
  keys: readonly KeyCap[]
  /** Said instead of (or after) the keys. */
  note?: string
}

const cap = (label: string, code: string): KeyCap => ({ label, code })

export const JUMP_KEYS: readonly KeyCap[] = [
  cap('Space', 'Space'),
  cap('W', 'KeyW'),
  cap('↑', 'ArrowUp'),
]
export const ITEM_KEYS: readonly KeyCap[] = [
  cap('E', 'KeyE'),
  cap('Enter', 'Enter'),
  cap('Ctrl', 'ControlLeft'),
]
export const RIDE_KEYS: readonly KeyCap[] = [cap('Q', 'KeyQ')]

export const KEYBOARD: readonly ControlRow[] = [
  { action: 'Jump', keys: JUMP_KEYS },
  { action: 'Double jump', keys: [], note: 'Jump again in the air' },
  { action: 'Use item', keys: ITEM_KEYS },
  { action: 'Ride', keys: RIDE_KEYS, note: 'when the meter is full' },
  {
    action: 'Emotes',
    keys: [cap('1', 'Digit1'), cap('2', 'Digit2'), cap('3', 'Digit3'), cap('4', 'Digit4')],
  },
  { action: 'Mute', keys: [cap('M', 'KeyM')] },
  { action: 'Leave the race', keys: [cap('Esc', 'Escape')], note: 'asks first' },
]

export const TOUCH: readonly ControlRow[] = [
  { action: 'Jump', keys: [], note: 'Tap the left half of the screen' },
  { action: 'Double jump', keys: [], note: 'Tap again in the air' },
  { action: 'Use item', keys: [], note: 'Tap the item disc or the right half' },
  { action: 'Ride', keys: [], note: 'Tap the Ride button when the meter is full' },
]
